import { ReduxUtils } from '../../../dependencies';
import { types } from '../../actions';

const actionTypes = {
    REQUEST: types.UPDATE_MEMBERSHIP_REQUEST,
    SUCCESS: types.UPDATE_MEMBERSHIP_SUCCESS,
    FAILURE: types.UPDATE_MEMBERSHIP_FAILURE,
    CANCEL: types.UPDATE_MEMBERSHIP_CANCEL,
};

const basicReducer = ReduxUtils.basicApiReducer({
    actionTypes,
});

export default ReduxUtils.containerReducer({
    childReducer: basicReducer,
    actionTypes: Object.values(actionTypes),
    selectors: {
        itemId: action => action.meta.id,
    },
});
